import { render, staticRenderFns } from "./NavLink.vue?vue&type=template&id=0b57e80e&scoped=true"
import script from "./NavLink.vue?vue&type=script&lang=js"
export * from "./NavLink.vue?vue&type=script&lang=js"
import style0 from "./NavLink.scss?vue&type=style&index=0&id=0b57e80e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b57e80e",
  null
  
)

export default component.exports